import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { ClickOutSideDirective } from '../../../../ui-components/directives/clickOutSide.directive';
import { TippyTooltipDirective } from '../../../../ui-components/lib/tooltip/tippy-tooltip.directive';

@Component({
  selector: 'lib-range-filter-dropdown',
  imports: [
    TranslocoPipe,
    ClickOutSideDirective,
    NgTemplateOutlet,
    TippyTooltipDirective,
  ],
  templateUrl: './range-filter-dropdown.component.html',
  styleUrl: './range-filter-dropdown.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class RangeFilterDropdownComponent {
  selectedRangeFilter = input.required<{ label: string; value: string }>();
  rangeFilterOptions = input.required<{ label: string; value: string }[]>();
  hasToggleAction = input<boolean>(true);
  hasTranslatedLabel = input<boolean>(false);
  dropdownClass = input<string>('');
  /** Opens the options in a Tippy popover on document.body, so a card's edge never clips them. */
  popover = input<boolean>(false);
  selectRangeFilter = output<{ label: string; value: string }>();
  toggleRangeFilter = signal<boolean>(false);

  handleSelectRangeFilter(option: { label: string; value: string }) {
    this.selectRangeFilter.emit(option);
    this.toggleRangeFilter.set(false);
  }
}
